import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    margin-top:3em;
`;
export const ButtonContainer = styled.div`
    display:flex;
    justify-content: flex-start;
    @media (max-width: 1100px) {
        display: none;
    }
`;
type TabProps = {
    $selected: boolean;
}
export const TabButton = styled.button<TabProps>`
    color: ${props => props.$selected ? "var(--main-teal-color)" : "#fff"};
    border:none;
    font-size:1em;
    margin-right: 1em;
    font-family: Lato-Bold;
    background-color: ${props => props.$selected ? "var(--main-light-grey-color)" : "var(--main-teal-color)"};
    ${props => props.$selected && "margin-bottom: -3px"};
    border-bottom: ${props => props.$selected ? "var(--main-light-grey-color)" : "none"};
    padding: 0.3em 3em 0.3em 3em;
    z-index: 1;
    @media (max-width: 1100px) {
        visibility: hidden;
    }
`;
export const Content = styled.div`
    padding:2em;
    background-color: var(--main-light-grey-color);
    margin-bottom: 12px;
`;
export const ConfigurationContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`;
export const MotorohomeImg = styled.img`
    margin:1em;
    width: 80%;
    max-width: 600px;
`;
export const MobileTab = styled.h4`
    width: 100%;
    color: var(--main-teal-color);
    font-family: Lato-Bold;
    @media (max-width: 1500px) {
        text-align:center;
    }
`;